import { render, staticRenderFns } from "./ЕditPageTournament.vue?vue&type=template&id=6848c3c0&scoped=true"
import script from "./ЕditPageTournament.vue?vue&type=script&lang=js"
export * from "./ЕditPageTournament.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./ЕditPageTournament.vue?vue&type=style&index=1&id=6848c3c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6848c3c0",
  null
  
)

export default component.exports